import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {groupsTabStateSelector} from './groups-tab-state.slice';

import type {GroupSortField, GroupsTabFilters} from '../typedef';
import type {CachedTableCacheSelector, CachedTableDataSelector} from 'src/hooks/common-data-service/cached-table/typedef';


export const groupsTabMembersSlice = getCachedTableDataSlice<
    Record<string, string>,
    undefined,
    GroupSortField,
    GroupsTabFilters
>('groupsTabMembers');

export const groupsTabMembersActions = groupsTabMembersSlice.actions;
export const groupsTabMembersCacheSelector: CachedTableCacheSelector<Record<string, string>> =
    state => state.accountPage.tabs.usersAndGroups.accountGroups.members.cache;
export const groupsTabMembersDataSelector: CachedTableDataSelector<Record<string, string>> =
    state => state.accountPage.tabs.usersAndGroups.accountGroups.members;

export const groupsTabMembersResultSelector = getCachedTableResultSelector(
    groupsTabMembersCacheSelector,
    groupsTabStateSelector,
);
